import { render, staticRenderFns } from "./yearly_sale_target.vue?vue&type=template&id=61661f74&scoped=true"
import script from "./yearly_sale_target.vue?vue&type=script&lang=js"
export * from "./yearly_sale_target.vue?vue&type=script&lang=js"
import style0 from "./yearly_sale_target.vue?vue&type=style&index=0&id=61661f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61661f74",
  null
  
)

export default component.exports